// import React, { useState } from 'react';
import './DigitalMarketingSection.css';

const DigitalMarketingSection = () => {
  // const [showModal, setShowModal] = useState(false);

  const profiles = [
    { name: 'Tech Solutions', followers: '50K', posts: 245 },
    { name: 'AI Innovations', followers: '75K', posts: 312 },
    { name: 'Digital Trends', followers: '100K', posts: 489 },
    { name: 'Future Labs', followers: '65K', posts: 198 },
    { name: 'Smart Tech', followers: '85K', posts: 356 }
  ];

  const campaigns = [
    { platform: 'Instagram', icon: '📷', reach: '2.5M', engagement: '8.5%' },
    { platform: 'WhatsApp', icon: '💬', reach: '1.8M', engagement: '12.3%' },
    { platform: 'Google Ads', icon: '🔍', reach: '3.2M', engagement: '6.7%' },
    { platform: 'Facebook', icon: '👥', reach: '2.1M', engagement: '7.9%' }
  ];

  return (
    <section className="digital-marketing-section section">
      <div className="section-content">
        <h2 className="section-title">Digital Marketing & Campaigns</h2>
        
        <h3 className="subsection-title">Social Media Management</h3>
        <div className="profiles-scroll">
          {profiles.map((profile, index) => (
            <div key={index} className="profile-card">
              <div className="profile-phone">
                <div className="profile-header">
                  <div className="profile-avatar">{profile.name.charAt(0)}</div>
                  <div className="profile-info">
                    <div className="profile-name">{profile.name}</div>
                    <div className="profile-stats">
                      <span>{profile.followers} followers</span>
                    </div>
                  </div>
                </div>
                <div className="profile-grid">
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className="profile-post"></div>
                  ))}
                </div>
                <div className="profile-posts-count">{profile.posts} posts</div>
              </div>
            </div>
          ))}
        </div>

        <h3 className="subsection-title">Ad Campaigns</h3>
        <div className="campaigns-grid">
          {campaigns.map((campaign, index) => (
            <div key={index} className="campaign-card">
              <div className="campaign-icon">{campaign.icon}</div>
              <h4 className="campaign-platform">{campaign.platform}</h4>
              <div className="campaign-stats">
                <div className="stat">
                  <div className="stat-label">Reach</div>
                  <div className="stat-value">{campaign.reach}</div>
                </div>
                <div className="stat">
                  <div className="stat-label">Engagement</div>
                  <div className="stat-value">{campaign.engagement}</div>
                </div>
              </div>
              <div className="campaign-chart">
                <div className="chart-bar" style={{ height: `${Math.random() * 60 + 40}%` }}></div>
                <div className="chart-bar" style={{ height: `${Math.random() * 60 + 40}%` }}></div>
                <div className="chart-bar" style={{ height: `${Math.random() * 60 + 40}%` }}></div>
                <div className="chart-bar" style={{ height: `${Math.random() * 60 + 40}%` }}></div>
              </div>
            </div>
          ))}
        </div>

        {/* Temporarily commented out View All Packages button and modal */}
        {/* <button className="view-all-btn" onClick={() => setShowModal(true)}>
          View All Packages
        </button>

        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
              <h3>Marketing Packages</h3>
              <div className="packages">
                <div className="package">
                  <h4>Starter</h4>
                  <p className="price">$999/mo</p>
                  <ul>
                    <li>Social Media Management</li>
                    <li>2 Platforms</li>
                    <li>10 Posts/month</li>
                    <li>Basic Analytics</li>
                  </ul>
                </div>
                <div className="package featured">
                  <div className="badge">Popular</div>
                  <h4>Professional</h4>
                  <p className="price">$2,499/mo</p>
                  <ul>
                    <li>Social Media Management</li>
                    <li>4 Platforms</li>
                    <li>30 Posts/month</li>
                    <li>Advanced Analytics</li>
                    <li>Ad Campaigns</li>
                  </ul>
                </div>
                <div className="package">
                  <h4>Enterprise</h4>
                  <p className="price">Custom</p>
                  <ul>
                    <li>Full Digital Marketing</li>
                    <li>Unlimited Platforms</li>
                    <li>Unlimited Posts</li>
                    <li>AI-Powered Analytics</li>
                    <li>Dedicated Team</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )} */}
      </div>
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default DigitalMarketingSection;
